// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or___3_5W","inputWrap":"styles_inputWrap__3Y0wK","input":"styles_input__q4bHd"};